import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from '../ui/Styles';
import Thumb from '../Thumb';
import { Container, Title, SubTitle } from './Styles';

const Home = ({ work }) => (
  <Container>
    <Row>
      <Column width={[1, 1 / 2]}>
        <Title>Saibot's Workshop</Title>
      </Column>
      <Column width={[1, 1 / 2]}>
        <SubTitle>
          Tobias Ighofose's Online Portfolio<small>
            Interactive Games/Front-end Developer
          </small>
        </SubTitle>
      </Column>
    </Row>
    <Row>
      {work &&
        work.map((item, i) => {
          return (
            <Column key={`${item.id}${i}`} w={[1, 1 / 2, 1 / 3, 1 / 4]}>
              <Thumb index={i} item={item} />
            </Column>
          );
        })}
    </Row>
  </Container>
);

Home.propTypes = { work: PropTypes.arrayOf(PropTypes.shape({}).isRequired) };

export default Home;



// WEBPACK FOOTER //
// ./src/components/HomePage/index.js